export default "__VITE_ASSET__14f70c03__"